import React, { useState, memo } from 'react';
import { Heart, Star, Send, Check } from 'lucide-react';
type Comment = {
  username: string;
  stars: number;
  text: string;
  likes: number;
  time: string;
};
const initialComments: Comment[] = [{
  username: '@maria_enfermeria_bsas',
  stars: 5,
  text: 'Apliqué el plan de 14 días desde la primera semana. Ahorro más de 8 horas por semana de estudio desorganizado. Vale cada centavo.',
  likes: 47,
  time: 'Hace 3 horas'
}, {
  username: '@lucas_medicina_cba',
  stars: 5,
  text: 'En dos semanas reduje mi tiempo de preparación un 80% sin cambiar mi método de estudio. Solo con los checklists fue suficiente.',
  likes: 32,
  time: 'Hace 5 horas'
}, {
  username: '@valentina_fisio_bog',
  stars: 5,
  text: 'La parte de autoevaluación me abrió los ojos. Nunca antes tuve un sistema tan claro para saber qué me faltaba repasar.',
  likes: 28,
  time: 'Hace 8 horas'
}, {
  username: '@camila_kinesio_mdp',
  stars: 4,
  text: 'Hay muchísimo material. Al principio pensé que no iba a usar todo pero después de organizarme cada página tiene sentido.',
  likes: 19,
  time: 'Hace 12 horas'
}, {
  username: '@diego_nutricion_ros',
  stars: 5,
  text: 'Las fichas de memorización rápida me salvaron la víspera del examen. Antes cada día de examen era puro caos.',
  likes: 24,
  time: 'Ayer'
}];
const morePool: Comment[] = [{
  username: '@sofia_odonto_mex',
  stars: 5,
  text: 'El mapa maestro de anatomía me cambió la forma de ver el cuerpo. Por fin entiendo cómo se conectan los sistemas.',
  likes: 38,
  time: 'Hace 1 día'
}, {
  username: '@joaquin_med_scl',
  stars: 5,
  text: 'Aprobé anatomía con 9 después de venir arrastrando la materia. Las 291 preguntas de autoevaluación son oro puro.',
  likes: 52,
  time: 'Hace 1 día'
}, {
  username: '@isabella_enf_med',
  stars: 5,
  text: 'Lo recomendé a toda mi cohorte. Es increíble que algo tan completo cueste menos que un libro de texto.',
  likes: 41,
  time: 'Hace 1 día'
}, {
  username: '@martina_fisio_uio',
  stars: 5,
  text: 'La guía express de términos anatómicos me salvó el primer parcial. Tener los prefijos y sufijos juntos es genial.',
  likes: 29,
  time: 'Hace 1 día'
}, {
  username: '@tomas_kin_mvd',
  stars: 4,
  text: 'Muy práctico, directo, nada de relleno. Para por fin tener un método de estudio claro vale todo.',
  likes: 16,
  time: 'Hace 2 días'
}, {
  username: '@agustina_med_lim',
  stars: 5,
  text: 'Pensé que era demasiado bueno para ser verdad. Lo uso hace 3 semanas y mis notas mejoraron de 6 a 9. Increíble.',
  likes: 56,
  time: 'Hace 2 días'
}, {
  username: '@nicolas_nutri_bog',
  stars: 5,
  text: 'Las 25 fichas visuales son perfectas para el repaso de último minuto. Llego a los exámenes con todo fresco.',
  likes: 33,
  time: 'Hace 2 días'
}, {
  username: '@florencia_enf_mdz',
  stars: 5,
  text: 'El checklist por sistemas me dio confianza real. Nunca más voy a llegar al examen con la duda de si me faltó algo.',
  likes: 27,
  time: 'Hace 2 días'
}, {
  username: '@pablo_med_qro',
  stars: 4,
  text: 'Genial el sistema de 4 niveles de dominio. Me ayuda a saber dónde tengo que poner más esfuerzo cada semana.',
  likes: 14,
  time: 'Hace 2 días'
}, {
  username: '@josefina_odo_san',
  stars: 5,
  text: 'Para estudiantes latinos no había algo así. Es el recurso que faltaba. Lo voy a usar toda la carrera.',
  likes: 44,
  time: 'Hace 3 días'
}];
const StarRating = ({
  value,
  onChange,
  size = 'w-7 h-7',
  interactive = false
}: {
  value: number;
  onChange?: (v: number) => void;
  size?: string;
  interactive?: boolean;
}) => <div className="flex items-center gap-1" data-id="element-220">
    {[1, 2, 3, 4, 5].map(i => <button key={i} type="button" onClick={() => interactive && onChange?.(i)} disabled={!interactive} aria-label={`${i} estrellas`} className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} ${i <= value ? 'text-gold-400' : 'text-gray-600'}`} data-id="element-221">
        <Star className={`${size} ${i <= value ? 'fill-current' : ''}`} data-id="element-222" />
      </button>)}
  </div>;
export function CommentsSection() {
  const [text, setText] = useState('');
  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [extraComments, setExtraComments] = useState<Comment[]>([]);
  const [likedSet, setLikedSet] = useState<Set<string>>(new Set());
  const allComments = [...initialComments, ...extraComments];
  const visible = allComments.slice(0, visibleCount);
  const canLoadMore = visibleCount < initialComments.length + morePool.length;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim() || rating === 0) return;
    setSubmitted(true);
    setText('');
    setName('');
    setRating(0);
    setTimeout(() => setSubmitted(false), 5000);
  };
  const handleLoadMore = () => {
    const start = extraComments.length;
    const next = morePool.slice(start, start + 5);
    setExtraComments([...extraComments, ...next]);
    setVisibleCount(visibleCount + 5);
  };
  const toggleLike = (username: string) => {
    setLikedSet(prev => {
      const next = new Set(prev);
      if (next.has(username)) next.delete(username);else next.add(username);
      return next;
    });
  };
  return <section className="mb-20" data-id="element-223">
      <div className="text-center mb-10" data-id="element-224">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 uppercase tracking-tight" data-id="element-225">
          Opiniones de estudiantes que ya usan el sistema
        </h2>
        <p className="text-gray-400" data-id="element-226">
          Más de 800 estudiantes ya cambiaron su forma de estudiar anatomía
        </p>
      </div>

      <div className="max-w-2xl mx-auto glass-panel border-gold-500/20 rounded-2xl p-6 md:p-8 mb-10 relative" data-id="element-227">
        {submitted && <div className="absolute inset-0 z-20 flex items-center justify-center bg-dark-900/95 backdrop-blur-sm rounded-2xl border border-emerald-500/30 p-6" data-id="element-228">
            <div className="text-center" data-id="element-229">
              <div className="w-16 h-16 rounded-full bg-emerald-500/20 border border-emerald-500/40 flex items-center justify-center mx-auto mb-4" data-id="element-230">
                <Check className="w-8 h-8 text-emerald-400" data-id="element-231" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-232">
                ¡Gracias por tu comentario!
              </h3>
              <p className="text-gray-400 max-w-sm mx-auto" data-id="element-233">
                Tu reseña será publicada en breve después de la moderación.
              </p>
            </div>
          </div>}

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-234">
          <div data-id="element-235">
            <label className="block text-white font-bold mb-3" data-id="element-236">
              Dejá tu reseña para la comunidad:
            </label>
            <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Escribí acá tu experiencia con el Mega Pack..." rows={4} className="w-full bg-dark-800 border border-white/10 rounded-xl p-4 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500/50 focus:ring-1 focus:ring-gold-500/30 transition-colors resize-none" required data-id="element-237" />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-238">
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre (opcional)" className="flex-1 bg-dark-800 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500/50 focus:ring-1 focus:ring-gold-500/30 transition-colors text-sm" data-id="element-239" />
            <div className="flex items-center gap-3" data-id="element-240">
              <span className="text-gray-400 text-sm font-medium" data-id="element-241">
                Calificá:
              </span>
              <StarRating value={rating} onChange={setRating} interactive size="w-6 h-6" data-id="element-242" />
            </div>
          </div>

          <button type="submit" disabled={!text.trim() || rating === 0} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold uppercase tracking-wider text-sm transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:translate-y-0 shadow-lg shadow-gold-500/20" data-id="element-243">
            <Send className="w-4 h-4" data-id="element-244" />
            Publicar
          </button>
        </form>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-245">
        {visible.map((c, i) => {
        const liked = likedSet.has(c.username);
        const likeCount = c.likes + (liked ? 1 : 0);
        return <div key={`${c.username}-${i}`} className="glass-panel rounded-2xl p-5 md:p-6 border-white/5 hover:border-white/10 transition-colors" data-id="element-246">
              <div className="flex items-start justify-between gap-3 mb-2" data-id="element-247">
                <div className="flex items-center gap-3 min-w-0" data-id="element-248">
                  <div className="w-10 h-10 rounded-full bg-gold-500/15 border border-gold-500/30 flex items-center justify-center text-gold-400 font-bold shrink-0" data-id="element-249">
                    {c.username.charAt(1).toUpperCase()}
                  </div>
                  <span className="text-gold-400 font-bold truncate" data-id="element-250">
                    {c.username}
                  </span>
                </div>
                <StarRating value={c.stars} size="w-4 h-4" data-id="element-251" />
              </div>

              <p className="text-gray-200 leading-relaxed mb-3 text-[15px]" data-id="element-252">
                {c.text}
              </p>

              <div className="flex items-center gap-5 text-sm" data-id="element-253">
                <button onClick={() => toggleLike(c.username)} className={`flex items-center gap-1.5 transition-colors ${liked ? 'text-red-400' : 'text-gray-500 hover:text-gray-300'}`} aria-label={liked ? 'Quitar me gusta' : 'Dar me gusta'} data-id="element-254">
                  <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} data-id="element-255" />
                  <span className="font-medium" data-id="element-256">{likeCount} Me gusta</span>
                </button>
                <span className="text-gray-500" data-id="element-257">{c.time}</span>
              </div>
            </div>;
      })}

        {canLoadMore && <div className="flex justify-center pt-4" data-id="element-258">
            <button onClick={handleLoadMore} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-dark-800 border border-white/10 hover:border-gold-500/30 text-white font-semibold transition-colors" data-id="element-259">
              Cargar 5 comentarios más
            </button>
          </div>}
      </div>
    </section>;
}